import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      - La ĉambro devas esti fermita, - asertas la Porda Tenilo, kiam oni fermas la pordon.
    </p>
    
    <p class="mb-3">
      - La ĉambro devas esti malfermita, - filozofumas ĝi, kiam la pordon oni malfermas.
    </p>
    
    <p class="mb-3">
      La konvinkoj de la Porda Tenilo plene dependas de tio, kiu premas ĝin.
    </p>
    `
  )
}

const itemName = {
  esp: 'La forto de konvinko'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;